<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">인사제도</h3>
      </div>
      <div class="txt">
        <h4 class="fs-30">승진제도</h4>
        <p class="pdt30 pdb50">
          <img :src="require('./../../assets/img/sub/04/0402_01.png')" />
        </p>

        <h4 class="fs-30 pdt50">교육제도</h4>
        <p class="pdt30 pdb50">
          <img :src="require('./../../assets/img/sub/04/0402_02.png')" />
        </p>

        <h4 class="fs-30 pdt50">복리후생</h4>
        <ul class="welfare">
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_03.png')" />
              </dd>
              <dt>여름휴가 제도</dt>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_04.png')" />
              </dd>
              <dt>휴양시설 혜택</dt>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_05.png')" />
              </dd>
              <dt>자녀 학자금 지원</dt>
            </dl>
          </li>
        </ul>
        <ul class="welfare">
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_06.png')" />
              </dd>
              <dt>경조휴가/경조금 지원</dt>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_07.png')" />
              </dd>
              <dt>정기종합검진/건강비 지원</dt>
            </dl>
          </li>
          <li>
            <dl>
              <dd class="img">
                <img :src="require('./../../assets/img/sub/04/0402_08.png')" />
              </dd>
              <dt>근속포상</dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Personnel.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub04/Personnel.vue